// GENERATED by scripts/gen-hooks.mjs. Do not edit by hand.
// 22 hooks for backend/grievances.

import { useBackend } from '../useBackend'

/** POST /api/grievances/addGrievanceNote */
export function useAddGrievanceNote<T = any>() {
  return useBackend<T>('grievances/addGrievanceNote')
}

/** POST /api/grievances/addGrievanceParty */
export function useAddGrievanceParty<T = any>() {
  return useBackend<T>('grievances/addGrievanceParty')
}

/** POST /api/grievances/answerGrievance */
export function useAnswerGrievance<T = any>() {
  return useBackend<T>('grievances/answerGrievance')
}

/** POST /api/grievances/confirmGrievanceGuard */
export function useConfirmGrievanceGuard<T = any>() {
  return useBackend<T>('grievances/confirmGrievanceGuard')
}

/** POST /api/grievances/confirmGrievanceIdentity */
export function useConfirmGrievanceIdentity<T = any>() {
  return useBackend<T>('grievances/confirmGrievanceIdentity')
}

/** POST /api/grievances/escalateGrievance */
export function useEscalateGrievance<T = any>() {
  return useBackend<T>('grievances/escalateGrievance')
}

/** POST /api/grievances/getGrievance */
export function useGetGrievance<T = any>() {
  return useBackend<T>('grievances/getGrievance')
}

/** POST /api/grievances/getGrievanceGuard */
export function useGetGrievanceGuard<T = any>() {
  return useBackend<T>('grievances/getGrievanceGuard')
}

/** POST /api/grievances/getGrievanceOptions */
export function useGetGrievanceOptions<T = any>() {
  return useBackend<T>('grievances/getGrievanceOptions')
}

/** POST /api/grievances/getGrievances */
export function useGetGrievances<T = any>() {
  return useBackend<T>('grievances/getGrievances')
}

/** POST /api/grievances/getGrievancesAccess */
export function useGetGrievancesAccess<T = any>() {
  return useBackend<T>('grievances/getGrievancesAccess')
}

/** POST /api/grievances/joinGrievances */
export function useJoinGrievances<T = any>() {
  return useBackend<T>('grievances/joinGrievances')
}

/** POST /api/grievances/logGrievance */
export function useLogGrievance<T = any>() {
  return useBackend<T>('grievances/logGrievance')
}

/** POST /api/grievances/makeGrievanceFormLink */
export function useMakeGrievanceFormLink<T = any>() {
  return useBackend<T>('grievances/makeGrievanceFormLink')
}

/** POST /api/grievances/openGrievanceFile */
export function useOpenGrievanceFile<T = any>() {
  return useBackend<T>('grievances/openGrievanceFile')
}

/** POST /api/grievances/reclassifyGrievance */
export function useReclassifyGrievance<T = any>() {
  return useBackend<T>('grievances/reclassifyGrievance')
}

/** POST /api/grievances/recordGrievanceCcma */
export function useRecordGrievanceCcma<T = any>() {
  return useBackend<T>('grievances/recordGrievanceCcma')
}

/** POST /api/grievances/recordGrievanceLate */
export function useRecordGrievanceLate<T = any>() {
  return useBackend<T>('grievances/recordGrievanceLate')
}

/** POST /api/grievances/recordGrievanceMeeting */
export function useRecordGrievanceMeeting<T = any>() {
  return useBackend<T>('grievances/recordGrievanceMeeting')
}

/** POST /api/grievances/setGrievanceHarassmentRoute */
export function useSetGrievanceHarassmentRoute<T = any>() {
  return useBackend<T>('grievances/setGrievanceHarassmentRoute')
}

/** POST /api/grievances/signGrievanceUpload */
export function useSignGrievanceUpload<T = any>() {
  return useBackend<T>('grievances/signGrievanceUpload')
}

/** POST /api/grievances/withdrawGrievance */
export function useWithdrawGrievance<T = any>() {
  return useBackend<T>('grievances/withdrawGrievance')
}
